export const Product = {
  isBrowseOnly: {
    // eslint-disable-next-line id-length
    read(_, _ref) {
      let {
        readField
      } = _ref;
      const fulfillment = readField('fulfillment');
      const availabilityType = readField('availabilityType');
      if (!fulfillment || !availabilityType) return null;
      const fulfillable = !!((fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.fulfillmentOptions) || []).find(option => option.fulfillable);
      const availableOnline = (availabilityType === null || availabilityType === void 0 ? void 0 : availabilityType.type) === 'Online';
      return availableOnline && !fulfillable;
    }
  },
  fulfillmentMethod: {
    read() {
      console.log('fulfillmentMethod resolver is deprecated');
      return null;
    }
  }
};
//# sourceMappingURL=Product.js.map